import { EmailPayload } from "./contact/payload";

const ENDPOINTS = {
    benefit: "benefit",
    event: "event",
    interaction: "interaction",
    attachment: "attachment",
};

export const APPLIED_STATUS = "APPLIED_FOR_BENEFIT";

export enum BenefitType {
    BackToSchoolGrant = "Back to School Grant",
    CulturalGrant = "Cultural Grant",
    EmergencyGrant = "Emergency Grant",
    HauoraGrant = "Hauora Grant",
    SportsGrant = "Sports Grant",
    SymposiumGrant = "Symposium Grant",
}

export enum EventType {}

interface BenefitPayload {
    benefitDescription: BenefitType;
    benefitStatus: typeof APPLIED_STATUS;
    benefitDate: Number;
}

interface EventPayload {
    eventDescription: EventType;
    eventDate: Number;
}

interface InteractionPayload {
    interaction: string;
    interactionDate: Number;
}

export interface GrantPayload {
    data: {
        benefit?: BenefitPayload;
        event?: EventPayload;
        interaction?: InteractionPayload;
        email?: EmailPayload;
    };
    recaptcha: string | null;
    tenant: string;
    targetId?: number;
}

export interface AttachmentResponse {
    data: {
        id: number;
        url: string;
    }[];
}

export function personEndpoint(id: number, endpoint: string) {
    return `/person/${id}/${endpoint}`;
}

export function benefitEndpoint(id: number) {
    return personEndpoint(id, ENDPOINTS.benefit);
}

export function eventEndpoint(id: number) {
    return personEndpoint(id, ENDPOINTS.event);
}

export function interactionEndpoint(id: number) {
    return personEndpoint(id, ENDPOINTS.interaction);
}

export function attachmentEndpoint(id?: number) {
    return `/${ENDPOINTS.attachment}${id ? `/${id}` : ""}`;
}
